import { Component, Vue } from 'vue-property-decorator'
import * as Bowser from 'bowser'

@Component({})
export default class CollectionTip extends Vue {
    public get isAdded() {
        return this.$store.state.isAdded
    }
    public get collectStep() {
        return this.$store.state.collectStep
    }
    private get isCollected () {
        return this.$store.state.collectStep !== 1
    }
    // 加入收藏
    public addFavorite() {
        let url = window.location.origin // 取主页地址
        let title = '一起题库网' // 命名为一起题库网
        let ua = navigator.userAgent.toLowerCase()

        const { os } =  Bowser.parse(window.navigator.userAgent)
        
        // 埋点
        window['sensors'].track('TIKU_collect_clk', {
            buttonName: '去收藏'
        })

        if (ua.indexOf("msie 8") > -1) {
            (window as any).external.AddToFavoritesBar(url, title) //IE8
            this.$store.commit('SET_COLLECT_STEP', 2)
        } else {
            try {
                (window as any).external.addFavorite(url, title)
            } catch (e) {
                try {
                    (window as any).sidebar.addPanel(title, url, '')
                } catch (e) {
                    this.$warning({
                        title: os.name === 'macOS' ? '您的浏览器暂不支持快速收藏，请按 Command 和 D 键，手动收藏页面吧' : '您的浏览器暂不支持快速收藏，请按 CTRL 和 D 键，手动收藏页面吧'
                    })
                }
            } finally {
                this.$store.commit('SET_COLLECT_STEP', 2)
            }
        }
    }
    public handleClkNo() {
        this.$store.commit('SET_IS_ADDED', true)
        this.$store.commit('SET_COLLECT_STEP', 2)
        // 埋点
        window['sensors'].track('TIKU_collect_clk', {
            buttonName: '不，谢谢'
        })
    }
    public handleClose() {
        this.$store.commit('SET_IS_ADDED', true)
        this.$store.commit('SET_COLLECT_STEP', 2)
        // 埋点
        window['sensors'].track('TIKU_collect_clk', {
            buttonName: '关闭'
        })
    }

    public mounted() {
        document.addEventListener('keyup', (e) => {
            console.log(e)
            // 没有办法监听command + d
        })
    }
}
